module.exports = __webpack_public_path__ + "img/slika-2.1aa1e277.png";